/**
 * Returns a Boolean corrsponding to whether or not the device/browser
 * in use is capable of hover events
 * @returns {boolean} true if device is hover event-capable; false if not
 */
const hashOver = () => {
  const hoverQuery = window.matchMedia('(hover: hover)');
  const anyQuery = window.matchMedia(
    '(any-hover: none), (any-pointer: coarse)'
  );
  return !!(hoverQuery.matches || !anyQuery.matches);
};

export default hashOver;
